export default {
  'admin.lic.server.mac.addr': {
    ko: 'OWLens View Server MAC 주소',
    ja: 'OWLensビューサーバーのMACアドレス',
    en: 'MAC address of OWLens server',
  },
  'admin.lic.feature.allowed': {
    ko: '허용된 기능',
    ja: '許可機能',
    en: 'Features allowed',
  },
  'admin.licensed.features': {
    ko: 'Licensed features',
    ja: 'ライセンス機能',
    en: 'Licensed features',
  },
  'admin.lic.apply.license': {
    ko: '라이선스 적용',
    ja: 'ライセンス適用',
    en: 'Apply license',
  },
  'admin.lic.ph.serial.input': {
    ko: '라이선스 문자열을 입력하세요.',
    ja: 'ライセンス文字列を入力してください。',
    en: 'Please, enter the license string.',
  },
  'admin.lic.lic.type': {
    ko: '라이선스 유형',
    ja: 'ライセンスタイプ',
    en: 'License type',
  },
  'admin.lic.count.cpu.core': {
    ko: 'CPU Core 개수',
    ja: 'CPUコア数',
    en: 'Number of CPU Core',
  },
  'admin.lic.end.date': {
    ko: '라이선스 만기일자',
    ja: 'ライセンス満期日',
    en: 'Ending date of license',
  },
  'admin.lic.serial': {
    ko: '라이선스 문자열',
    ja: 'ライセンス文字列',
    en: 'License string',
  },
  'admin.rights.statement': {
    en: 'ⓒ 2020~{year} META CORE GLOBAL ALL RIGHTS RESERVED.',
  },
  'admin.lic.count.inst': {
    ko: '인스턴스 서버 대수',
    ja: 'インスタンスサーバー数',
    en: 'Number of Instance Server',
  },
};
